//  ตัวอย่างการใช้งาน
// <InformListComponent
// items={this.props.informStore.getItems}
// showMenu={{
//   manageTask: true,
//   confirmJob: true,
//   closeInform: true,
//   reconfirmInform: true,
// }}
// onWorkstatusChange={(data) => {
//   this.getCountWorkStatus()
// }}
// showFormAdd={this.state.showFormAdd}
// onFormAddClose={(value) => {
//   this.setState({
//     showFormAdd: value,
//   })
//  manageTask
// }}
// />

import React from 'react'
import {
  InformfixService,
  HomeService,
  TechnicainService,
} from '../../services'
import {
  List,
  Avatar,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Popconfirm,
  notification,
  Tooltip,
  Form,
  Input,
} from 'antd'
import { Config } from '../../config'
import iconHome from '../../assets/images/informfix/icon-home.png'
import queryString from 'query-string'
import { Moment } from '../../helpers'
import { observer, inject } from 'mobx-react'
import InformView from './inform-view'
import InformFormAdd from './inform-form'
import InformEdit from './inform-edit'
import AssignJob from './assign-job'
import JobClose from './../../components/job/job-close'
import NotificationAdd from '../notification/notification-form'
import { InformfixStatus } from './InformfixStatus'
import {
  CheckSquareOutlined,
  CloseOutlined,
  ClockCircleFilled,
  HomeFilled,
  EditOutlined,
  PhoneFilled,
  SendOutlined,
  SearchOutlined,
  ReloadOutlined,
  DeleteOutlined,
  PrinterOutlined,
  DownloadOutlined,
  DownOutlined,
  EditFilled,
  CloseCircleFilled,
  CloseCircleOutlined,
  CalendarFilled,
  CalendarOutlined,
  DeleteRowOutlined,
} from '@ant-design/icons'

import JobPostpone from '../job/job-postpone'
import ButtonGroup from 'antd/lib/button/button-group'
import { InformfixPostponeDetail } from './InformfixPostponeDetail'
import imageCustomer from '../../assets/images/informfix/icon-customer.png'
import defaultImageCustomer from '../../assets/images/informfix/icon-customer-service.png'
import TextArea from 'antd/lib/input/TextArea'

import { has } from 'lodash'

const IconText = ({ icon, text, onClickAction }) => (
  <React.Fragment>
    {icon} {text}
  </React.Fragment>
)

const openNotificationWithIcon = (type, message, description = '') => {
  notification[type]({
    message: message ? message : 'Notification Title',
    description: description,
  })
}

const STATUS_INFORMFIX_OPEN = Config.informfix.status.OPEN.value //  สถานะใบแจ้งซ่อม: เปิดงาน
// const STATUS_INFORMFIX_WAIT = Config.informfix.status.WAIT.value //  สถานะใบแจ้งซ่อม: รอยืนยันลูกค้า
// const STATUS_INFORMFIX_CONFIRMED = Config.informfix.status.CONFIRMED.value //  สถานะใบแจ้งซ่อม: ยืนยันลูกค้าแล้ว
const STATUS_INFORMFIX_PROCEED = Config.informfix.status.PROCEED.value // สถานะใบแจ้งซ่อม: กำลังดำเนินการ  สำหรับใช้แสดงหน้าจัดคิวงาน
const STATUS_INFORMFIX_COMPLETE = Config.informfix.status.COMPLETE.value //  สถานะใบแจ้งซ่อม: เสร็จแล้ว
const STATUS_INFORMFIX_CANCELED = Config.informfix.status.CANCELED.value //  สถานะใบแจ้งซ่อม: ยกเลิก

function getMenuItem(label, key, icon, children, type, item) {
  return {
    key,
    icon,
    children,
    label,
    type,
    item: item,
  }
}

@inject('informStore')
@observer
class InformListComponent extends React.Component {
  constructor() {
    super()

    this.formCancelRef = React.createRef()
  }
  state = {
    loading: false,
    data: [],
    items: [],
    listJobStatus: [],
    homeDetail: {},
    photos: [],
    showFormView: false,
    showFormEdit: false,
    showFormAssign: false,
    showFormPostponeJob: false,
    showFormCancel: false,
    editId: 0,
    viewId: 0,
    viewDetailJobId: null,
  }

  static defaultProps = {
    showMenu: {
      editInform: false, // แก้ไขใบแจ้งซ่อม
      cancelInform: false, // ยกเลิกไปแจ้งซ่อม
      editJob: false, // แก้ไขคิวงาน
      editInofrmStatus: false, // แก้ไขสถานะใบแจ้ง
      manageTask: false, // จัดการคิวงาน
      manageInform: false, // จัดการใบแจ้งซ่อม
      confirmInform: false, // ยกเลิกใบแจ้งซ่อม
      reconfirmInform: false, // ยืนยันนัดหมาย
      confirmJob: false, // ยืนยันคิวงาน
      closeInform: false, // ปิดคิวงานให้เสร็จ
      showModalAdd: false, // แสดงหน้าเพิ่ม
      postponeJob: false, // ปุ่มเลื่อนนัด
      deleteInform: false, // ลบใบแจ้งซ่อม
    },
    items: [],
    name: 'Hello World.',
    technicians: [],
  }

  componentWillReceiveProps() {
    this.setState({
      items: this.props.items,
    })
  }

  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountAllStatus() {
    console.log('check count inform')
    InformfixService.countNewInform().then((rs) => {
      if (rs) {
        const data = rs.data
        this.props.informStore.countNewInform = data.total
      }
    })

    InformfixService.count4task().then((rs) => {
      if (rs) {
        const data = rs.data
        this.props.informStore.count4task = data.total
      }
    })

    InformfixService.countPostpone().then((rs) => {
      if (rs) {
        const data = rs.data
        this.props.informStore.countPostpone = data.total
      }
    })
  }

  getInform(item) {
    // this.props.informStore.setItem({})
    // this.props.informStore.setJobItems([])
    // this.props.informStore.setJob({})
    // this.props.informStore.setGalleryItems([])

    // ข้อมูบใบแจ้งซ่อม
    InformfixService.view(item.id).then((inform) => {
      if (inform['data']) {
        this.setState({
          inform: inform.data['data'],
        })
        this.props.informStore.setItem(inform.data['data'])

        // ข้อมูลบ้าน
        if (item.home) {
          HomeService.view(item.home.id).then((home) => {
            this.setState({
              visibleHomeDetail: true,
              homeDetail: home.data.data,
            })
            this.props.informStore.setHome(this.state.homeDetail)
          })
        }

        // jobs
        InformfixService.getJobs(item.id).then((rs) => {
          this.setState({
            informJobs: rs.data.data,
          })
          this.props.informStore.setJobItems(rs.data.data)
        })

        // รูปภาพต่าง ๆ
        InformfixService.getGallery(item.id).then((images) => {
          this.setState({ photos: images })
          this.props.informStore.setGalleryItems(images)
        })
      }
    })
  }

  getTechnicians() {
    TechnicainService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.data
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.id,
                text:
                  item.firstname +
                  ' ' +
                  item.lastname +
                  (item.technician_type
                    ? ' (' + item.technicianTypeName + ')'
                    : null),
              })
            })
          }
          this.setState({ technicians: data, techniciansTemp: items })
        }
      })
      .catch((err) => {})
  }

  showModalAdd = () => {
    this.setState({ showFormAdd: true })
    this.getTechnicians()
  }

  /**
   * ดูรายละเอียดใบแจ้งซ่อม
   */
  showModalView = (item) => {
    this.setState({
      inform: {},
      homeDetail: {},
      photos: [],
      showFormView: true,
    })
    this.getInform(item)
  }
  /**
   * แสดงแบบฟอร์มยกเลิก
   */
  showModalCancel = (item) => {
    if (item) {
      this.setState(
        {
          inform: item,
          homeDetail: {},
          photos: [],
          showFormCancel: true,
        },
        () => {},
      )
    }
  }

  /**
   * ดูรายละเอียดใบแจ้งซ่อม
   */
  showModalViewJob = (item) => {
    this.setState({
      viewDetailJobId: item.id,
      homeDetail: {},
      inform: {},
    })
    this.getInform(item)
  }
  /**
   * ดูรายละเอียดใบแจ้งซ่อม
   */
  showModalPostponeJob = (item) => {
    this.props.informStore.setJobItems([])
    this.props.informStore.setItem({})
    this.setState({
      viewId: item.id,
      showFormPostponeJob: true,
      homeDetail: {},
      inform: {},
    })
    this.getInform(item)
  }

  /**
   * แสดงแบบ Modal แก้ไขข้อูล
   */
  showModalEdit = (item, step = 0) => {
    this.props.informStore.setItem({})
    this.setState({
      editId: item.id,
      formStep: step,
    })
    InformfixService.view(item.id).then((rs) => {
      if (rs && rs.data.data) {
        const inform = rs.data.data
        this.setState({
          inform: inform,
          showFormEdit: true,
        })
        this.props.informStore.setItem(inform)
      }
    })
  }

  /**
   * แสดงแสดง Modal จัดคิวงาน
   */
  showModalAssign = (item) => {
    // inform
    this.setState({
      showFormAssign: true,
      editId: item.id,
    })
    InformfixService.view(item.id).then((rs) => {
      const inform = rs.data.data
      this.setState({
        inform: inform,
      })
      this.props.informStore.setItem(inform)
    })
    this.props.informStore.setEditId(item.id)
  }

  showModalNotification = (item) => {
    this.setState({
      showFormNotification: true,
      editId: item.id,
    })
  }

  hideModalAdd = () => {
    this.setState({ showFormAdd: false })
    this.props.onFormAddClose(false)
  }

  hideModalView = (e) => {
    this.setState({
      showFormView: false,
      homeDetail: {},
      galleries: [],
    })
    this.props.informStore.setEditId('')
  }
  hideModalViewJob = (e) => {
    this.setState({
      viewDetailJobId: 0,
      homeDetail: {},
      galleries: [],
      inform: {},
    })
    this.props.informStore.setEditId('')
  }

  hideModalEdit = () => {
    this.setState({
      showFormEdit: false,
      editId: '',
      inform: {},
    })
    this.props.informStore.setEditId('')
  }

  hideModalAssign = () => {
    this.setState({
      showFormAssign: false,
      editId: '',
    })
    this.props.informStore.setEditId('')
  }

  hideModalNotification = () => {
    this.setState({
      showFormNotification: false,
      editId: '',
    })
    this.props.informStore.setEditId('')
  }

  updateListInformfix = (row) => {
    const informfix = row
    if (informfix) {
      this.props.informStore.setItem(row)
      let list = this.props.informStore.getItems
      list.map((i, index) => {
        if (i.id == informfix.id) {
          list[index] = informfix
        }
      })
      this.props.informStore.setItems(list)
      this.props.onWorkstatusChange()
    }
  }

  /**
   * เปลี่ยนสถานะใบแจ้งซ่อม
   */
  setWorkStatus = (item, status) => {
    if (status.value != undefined) {
      this.setQueryString()
      InformfixService.setWorkStatus(item.id, {
        workstatus: status.value,
      }).then((rs) => {
        const inform = rs.data.data
        this.updateListInformfix(inform)
        openNotificationWithIcon('success', rs.data['message'])
        this.props.onWorkstatusChange()
        this.getCountAllStatus()
      })
    }
  }
  /**
   * ส่งไปแจ้งซ๋อมไปจัดคิว
   */
  sendToManageTask = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    InformfixService.send2task(inform.id, {}).then((rs) => {
      const data = rs.data.data
      const list = this.props.informStore.getItems
      list.map((item, index) => {
        if (item.id == row.id) {
          list[index] = data
          list.splice(index, 1)
          this.props.informStore.setItems(list)
          this.setState({
            data: list,
          })
          this.props.informStore.setItem(data)
          openNotificationWithIcon('success', rs.data.message)
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
        }
      })
    })
  }

  /**
   * ยกเลิกแจ้งซ่อม
   */
  cancelInform = (item, form) => {
    if (this.props.showMenu.cancelInform) {
      InformfixService.cancel(item.id, form).then((rs) => {
        if (rs) {
          const inform = rs.data.data
          let list = this.props.informStore.getItems
          list.map((i, index) => {
            if (i.id == inform.id) {
              list.splice(index, 1)
              this.setState({ list: list })
              this.props.informStore.setItems(list)
            }
          })
          openNotificationWithIcon('success', rs.data['message'])
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
          this.setState({
            showModalCancel: false
          })
        }
      })
    }
  }
  onSubmitCancel = () => {
    this.formCancelRef.current.submit()
  }
  handleSubmitCancel = (value) => {
    if (value) {
      this.cancelInform(this.state.inform, {
        id: value.id,
        canceled_remark: value.canceled_remark,
      })

    }
    return false
  }
  /**
   * ลบแจ้งซ่อม
   */
  deleteInform = (item) => {
    if (this.props.showMenu.deleteInform) {
      InformfixService.delete(item.id).then((rs) => {
        if (rs) {
          let list = this.props.informStore.getItems
          list.map((i, index) => {
            if (i.id == item.id) {
              list.splice(index, 1)
              this.setState({ list: list })
              this.props.informStore.setItems(list)
            }
          })
          openNotificationWithIcon('success', rs.data['message'])
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
        }
      })
    }
  }

  /**
   * เปลี่ยนสถานะใบแจ้งซ่อมปัจุจุบันเป็น[รอยืนยันลูกค้า]
   * เมื่อกดยืนยันการจัดคิวงานซ่อมในใบแจ้งซ่อม
   */
  confirmTask = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    console.log('changeStatusToWait', inform)
    // InformfixService.confirmTask(inform.id, {
    //   workstatus: STATUS_INFORMFIX_WAIT,
    // }).then((rs) => {
    //   const data = rs.data.data
    //   const list = this.props.informStore.getItems
    //   list.map((item, index) => {
    //     if (item.id == inform.id) {
    //       list[index] = data
    //       list.splice(index, 1)
    //       this.props.informStore.setItems(list)
    //       this.setState({
    //         data: list,
    //       })
    //       this.props.informStore.setItem(data)
    //       openNotificationWithIcon('success', rs.data.message)
    //       this.props.onWorkstatusChange()
    //       this.getCountAllStatus()
    //     }
    //   })
    // })
  }
  /**
   * ใบแจ้งซ่อมปัจุจุบันเป็น[รอยืนยันลูกค้า]
   * เมื่อกดยืนยันการจัดคิวงานซ่อมอีกครั้งหลังจากส่งกลับมาจัดคิวใหม่
   * เนื่องจากมีการเลื่อนนัด
   */
  /**
   * เปลี่ยนสถานะใบแจ้งซ่อมปัจุจุบันเป็น [ยืนยันแล้ว]
   * เมื่อกดยืนยันการจัดคิวงานซ่อมในใบแจ้งซ่อมจะเปลี่ยนสถานะเป็น [มอบหมายงานแล้ว]
   */
  changeStatusToConfirmed = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    console.log('changeStatusToConfirmed', inform)
    // InformfixService.comfirmInform(inform.id, {
    //   workstatus: STATUS_INFORMFIX_CONFIRMED,
    // }).then((rs) => {
    //   const data = rs.data.data
    //   const list = this.props.informStore.getItems
    //   list.map((item, index) => {
    //     if (item.id == inform.id) {
    //       list[index] = data
    //       list.splice(index, 1)
    //       this.props.informStore.setItems(list)
    //       this.setState({
    //         data: list,
    //       })
    //       this.props.informStore.setItem(data)
    //       openNotificationWithIcon('success', rs.data.message)
    //       this.props.onWorkstatusChange()
    //       this.getCountAllStatus()
    //     }
    //   })
    // })
  }
  reconfirmTask = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    console.log('reconfirmTask', inform)
    InformfixService.reconfirmTask(row.id).then((rs) => {
      const data = rs.data.data
      const list = this.props.informStore.getItems
      list.map((item, index) => {
        if (item.id == row.id) {
          list[index] = data
          list.splice(index, 1)
          this.props.informStore.setItems(list)
          this.setState({
            data: list,
          })
          this.props.informStore.setItem(data)
          openNotificationWithIcon('success', rs.data.message)
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
        }
      })
    })
  }

  /**
   * เปลี่ยนสถานะใบแจ้งซ่อมปัจุจุบันเป็น [อยู่ระหว่างดำเนินการ]
   * เมื่อกดยืนยันการจัดคิวงานซ่อมในใบแจ้งซ่อมจะเปลี่ยนสถานะเป็น [อยู่ระหว่างดำเนินการซ่อม]
   */
  changeStatusToProceed = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    console.log('changeStatusToProceed', inform)
    InformfixService.comfirmJob(inform.id, {
      workstatus: STATUS_INFORMFIX_PROCEED,
    }).then((rs) => {
      const data = rs.data.data
      const list = this.props.informStore.getItems
      list.map((item, index) => {
        if (item.id == inform.id) {
          list[index] = data
          list.splice(index, 1)
          this.props.informStore.setItems(list)
          this.setState({
            data: list,
          })
          this.props.informStore.setItem(data)
          openNotificationWithIcon('success', rs.data.message)
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
        }
      })
    })
  }
  /**
   * เปลี่ยนสถานะใบแจ้งซ่อมปัจุจุบันเป็น [ปิดงาน]
   * เมื่อกดยืนยันการจัดคิวงานซ่อมในใบแจ้งซ่อมจะเปลี่ยนสถานะเป็น [เสร็จแล้ว]
   */
  changeStatusToComplete = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    console.log('changeStatusToComplete', inform)
    InformfixService.close(inform.id, {
      workstatus: STATUS_INFORMFIX_COMPLETE,
    }).then((rs) => {
      const data = rs.data.data
      const list = this.props.informStore.getItems
      list.map((item, index) => {
        if (item.id == inform.id) {
          list[index] = data
          list.splice(index, 1)
          this.props.informStore.setItems(list)
          this.setState({
            data: list,
          })
          this.props.informStore.setItem(data)
          openNotificationWithIcon('success', rs.data.message)
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
        }
      })
    })
  }

  /**
   * เลื่อนนัดใบแจ้งซ่อมคงสถานะไว้ไม่ยุ่ง
   * เมื่อกดยืนยันการจัดคิวงานซ่อมในใบแจ้งซ่อมจะเปลี่ยนสถานะเป็น [เลื่อนนัดหมาย]
   */

  changeJobToPostpone = (row) => {
    this.props.informStore.setItem(row)
    const inform = this.props.informStore.getItem
    console.log('changeStatusToComplete', inform)
    InformfixService.close(inform.id, {
      workstatus: STATUS_INFORMFIX_COMPLETE,
    }).then((rs) => {
      const data = rs.data.data
      const list = this.props.informStore.getItems
      list.map((item, index) => {
        if (item.id == inform.id) {
          list[index] = data
          list.splice(index, 1)
          this.props.informStore.setItems(list)
          this.setState({
            data: list,
          })
          this.props.informStore.setItem(data)
          openNotificationWithIcon('success', rs.data.message)
          this.props.onWorkstatusChange()
          this.getCountAllStatus()
        }
      })
    })
  }

  printWord = (item) => {
    InformfixService.printWord(item.id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.pdf')
      document.body.appendChild(link)
      link.click()
      console.log('url', url)
      console.log('link', link)
    })
  }
  downloadDoc = (item) => {
    InformfixService.downloadDoc(item.linkExportWord).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.pdf')
      document.body.appendChild(link)
      link.click()
      console.log('url', url)
      console.log('link', link)
    })
  }

  render() {
    /**
     * เช็คเงื่อนไขการแก้ไข
     * @param {*} item
     */
    const CanEdit = (item) => {
      const status = item.work_status.toString()
      return (status == STATUS_INFORMFIX_OPEN ||
        status == STATUS_INFORMFIX_PROCEED) &&
        this.props.showMenu.editInform
        ? true
        : false
    }

    /**
     * เช็คเงื่อนไขแสดงปุ่มยกเลิก
     * @param {*} item
     */
    const CanCancel = (item) => {
      const status = item.work_status.toString()
      return status != STATUS_INFORMFIX_CANCELED.toString() &&
        status != STATUS_INFORMFIX_COMPLETE.toString() &&
        this.props.showMenu.cancelInform
        ? true
        : false
    }
    /**
     * เช็คเงื่อนไขแสดงปุ่มลบ
     * @param {*} item
     */
    const CanDelete = (item) => {
      const status = item.work_status.toString()
      const statusOK = status != STATUS_INFORMFIX_COMPLETE.toString()
      return statusOK && this.props.showMenu.deleteInform ? true : false
    }

    /**
     * เช็คเงื่อนการแสดงปุ่มจัดคิวงานหรือจัดการงาน
     * @param {*} item
     */
    const CanAssignJob = (item) => {
      const status = item.work_status
      const informAllow =
        status == !STATUS_INFORMFIX_CANCELED ||
        status == !STATUS_INFORMFIX_COMPLETE
      return informAllow && this.props.showMenu.manageTask ? true : false
    }

    /**
     * เปลี่ยสถานะเป็นเสร็จสิ้นและงานทั้งหมดเสร็จ
     */
    const CanSetToComplete = (item) => {
      if (item.work_status == STATUS_INFORMFIX_PROCEED) {
        return true
      } else {
        return false
      }
    }
    /**
     * ตรวจสอบการส่งไปจัดคิว
     */
    const CanSendToManageTask = (item) => {
      if (
        item.work_status == STATUS_INFORMFIX_OPEN &&
        item.step_work == 'add_inform' &&
        item.step_work != 'add_appointments'
      ) {
        return true
      } else {
        return false
      }
    }
    /**
     * สามารถส่งไปจัดคิวงาน
     */
    const CanSendToConfirm = (item) => {
      if (item.work_status == STATUS_INFORMFIX_OPEN) {
        return true
      } else {
        return false
      }
    }
    /**
     * สามารถส่งไปยืนยันใส่เวลานัดหมาย
     */
    const CanResendToConfirm = (item) => {
      if ((item.postpone_mark = 0 && this.props.manageTask)) {
        return true
      } else {
        return false
      }
    }

    /**
     * ตรวจสอบปุ่มกดยืนยันหมายเพื่อจ่ายงานให้ช่างทันที
     * ใบแจ้งซ่อมกลายเป็นสถานะ[ยืนยันนัดหมายแล้ว]
     */
    const CanConfirm = (item) => {
      if (
        item.work_status == STATUS_INFORMFIX_OPEN &&
        this.props.showMenu.confirmInform &&
        this.props.showMenu.manageInform &&
        item.postpone_mark == 0
      ) {
        return true
      } else {
        return false
      }
    }
    /**
     * ส่งงานใบแจ้งซ๋อมไปให้ช่าง
     * สถานะใบแจ้งซ๋อมจะเปลี่ยนเป็น [อยู่ระหว่างดำเนินการ]
     * คิวงานทั้งหมดจะถูกเปลี่ยนเป็น [อยู่ระหว่างดำเนินการซ่อม]
     *
     */
    const CanConfirmJob = (item) => {
      if (
        item.work_status == STATUS_INFORMFIX_OPEN &&
        this.props.showMenu.confirmJob
      ) {
        return true
      } else {
        return false
      }
    }
    /**
     * ปิดใบแจ้งซ๋อม
     * สถานะใบแจ้งซ๋อมจะเปลี่ยนเป็น [ปิดงาน]
     * คิวงานทั้งหมดจะถูกเปลี่ยนเป็น [เสร็จแล้ว]
     *
     */
    const CanCloseInform = (item) => {
      const CanDo = item.work_status == STATUS_INFORMFIX_PROCEED
      if (this.props.showMenu.closeInform && CanDo) {
        return true
      } else {
        return false
      }
    }
    /**
     * เลื่อนนัด
     * สถานะใบแจ้งซ๋อมจะเปลี่ยนเป็น [ปิดงาน]
     * คิวงานทั้งหมดจะถูกเปลี่ยนเป็น [เสร็จแล้ว]
     *
     */
    const CanPostponeJob = (item) => {
      const CanPostponeJobStatus =
        // item.work_status == STATUS_INFORMFIX_WAIT ||
        // item.work_status == STATUS_INFORMFIX_CONFIRMED ||
        item.work_status == STATUS_INFORMFIX_PROCEED

      if (
        CanPostponeJobStatus &&
        item.postpone_mark == 0 &&
        this.props.showMenu.postponeJob &&
        this.props.manageInform
      ) {
        return true
      } else {
        return false
      }
    }

    // const menuDropDownItems =  (item) => (
    //   <Menu onClick={this.handleMenuClick}>
    //     <Menu.Item key="1">ดาวน์โหลดแบบฟอร์มเข้าซ่อมบ้าน</Menu.Item>
    //     <Menu.Item key="2"></Menu.Item>
    //     <Menu.Item key="3">Clicking me will close the menu.</Menu.Item>
    //   </Menu>
    // )

    const handleMenuClick = ($e, item) => {
      console.log($e, item)
    }

    const showMenuDrowDown = (item) => {
      const items = [
        getMenuItem('แก้ไข', 'menu_edit', <EditFilled />),
        getMenuItem('ยกเลิก', 'menu_cancel', <DeleteRowOutlined />),
      ]
      return (
        <Dropdown
          key={item.id + 'ddddd'}
          overlay={() => (
            <>
              <Menu
                items={items}
                onClick={(e) => {
                  // console.log('click mentu', e.key, item)
                  switch (e.key) {
                    case 'menu_edit':
                      this.showModalEdit(item)
                      break
                    case 'menu_cancel':
                      this.showModalCancel(item)

                      break
                    default:
                      break
                  }
                }}
              />
            </>
          )}
        >
          <Button size="small">
             เมนูจัดการ
            <DownOutlined />
          </Button>
        </Dropdown>
      )
      // return (
      //   <Dropdown
      //     key={String(item.id) + 'download'}
      //     overlay={() => (
      //       <Menu onClick={this.handleMenuClick}>
      //         <Menu.Item
      //           icon={<DownOutlined />}
      //           key="dd-download"
      //           onClick={() => this.downloadDoc(item)}
      //         >
      //           ดาวน์โหลดแบบฟอร์มเข้าซ่อมบ้าน
      //         </Menu.Item>
      //         {/* ################## ปุ่มแก้ไขใบแจ้งซ่อม ################ */}
      //         {CanEdit(item) ? (
      //           <Menu.Item
      //             onClick={() => this.showModalEdit(item)}
      //             key="dd-edit"
      //             icon={<EditFilled />}
      //           >
      //             แก้ไข
      //           </Menu.Item>
      //         ) : null}
      //         {/* ################## ปุ่มยกเลิกใบแจ้งซ่อม ################ */}
      //         {CanCancel(item) ? (
      //           <Menu.Item
      //             key="dd-cancel"
      //             icon={<CloseCircleOutlined />}
      //             onClick={() => {
      //               Modal.confirm({
      //                 content:
      //                   'ต้องการยกเลิกใบแจ้งซ่อม ID#' +
      //                   item.id +
      //                   ' ใช่หรือไม่ ?',
      //                 onOk: (confirmed) => {
      //                   if (confirmed) {
      //                     console.log(confirmed)
      //                     // this.cancelInform(item)
      //                   }
      //                 },
      //               })
      //             }}
      //           >
      //             ยกเลิก
      //           </Menu.Item>
      //         ) : null}
      {
        /* ################## ปุ่มลบใบแจ้งซ่อม ################ */
      }
      //   {CanDelete(item) ? (
      //     <Menu.Item
      //       key="dd-del"
      //       icon={<DeleteOutlined />}
      //       onClick={() => {
      //         var confirmed = window.confirm(
      //           'ต้องการลบใบแจ้งซ่อม ID#' + item.id + ' ใช่หรือไม่ ?',
      //         )
      //         if (confirmed) {
      //           this.deleteInform(item)
      //         }
      //       }}
      //     >
      //       ลบ
      //     </Menu.Item>
      //   ) : null}
      // </Menu>
      // )}
      // onVisibleChange={this.handleVisibleChange}
      // >
      //   <Button size="small">
      //     Action
      //     <DownOutlined />
      //   </Button>
      // </Dropdown>
      // )
    }


    const listData = (
      <List
        itemLayout="vertical"
        size="small"
        pagination={false}
        dataSource={this.props.informStore.getItems}
        loading={this.props.loading ? this.props.loading.toString() : undefined}
        // footer={

        //     // <div>
        //     //   <b>ant design</b> footer part
        //     // </div>

        // }
        renderItem={(item) => (
          <List.Item
            key={item.title}
            style={{
              border: 'solid 1px #cccccc',
              marginBottom: 7,
              background:
                item.work_status == Config.informfix.status.OPEN.value
                  ? 'rgb(209 241 206)'
                  : 'rgba(255,255,255,1)',
            }}
            actions={[
              // <IconText
              //   icon={<ClockCircleFilled />}
              //   text={
              //     item.date_inform && Moment().isValid()
              //       ? Moment.unix(item.date_inform).format('lll')
              //       : null
              //   }
              //   key="list-vertical-star-o"
              // />,
              <IconText
                icon={<HomeFilled />}
                text={
                  item.project ? (
                    <React.Fragment>
                      {item.project ? item.project.name : null}
                    </React.Fragment>
                  ) : null
                }
                key="list-vertical-like-o"
              />,
              <IconText
                icon={<HomeFilled />}
                text={
                  item.home ? (
                    <React.Fragment>
                      {item.home
                        ? '' +
                          item.home.home_no +
                          (item.home.plan_no
                            ? ' (แปลง' + item.home.plan_no + ')'
                            : null)
                        : null}
                    </React.Fragment>
                  ) : null
                }
                key="list-vertical-homeno"
              />,
              <IconText
                icon={<PhoneFilled />}
                text={
                  <React.Fragment>
                    <a
                      href={`tel:${
                        item.contact_phone ? item.contact_phone : item.telephone
                      }`}
                      title="คลิ๊กโทรหาลูกค้า"
                    >
                      {item.contact_phone ? item.contact_phone : item.telephone}
                    </a>
                  </React.Fragment>
                }
                key="list-vertical-phone"
              />,
            ]}
            extra={
              <div>
                <div
                  style={{
                    textAlign: 'center',
                    marginBottom: 3,
                  }}
                >
                  <InformfixStatus
                    name={item.workStatusName}
                    statusId={item.work_status}
                    style={{
                      display: 'block',
                    }}
                  />
                </div>
                {item.cover ? (
                  <img
                    width={100}
                    alt="logo"
                    src={item.cover ? item.cover.thumbnail : iconHome}
                    onClick={() => this.showModalView(item)}
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                ) : (
                  <img
                    width={100}
                    alt="logo"
                    src={item.cover ? item.cover.thumbnail : iconHome}
                    onClick={() => this.showModalView(item)}
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                )}
              </div>
            }
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  src={
                    item.member_id > 0 ? imageCustomer : defaultImageCustomer
                  }
                  onClick={() => this.showModalView(item)}
                  size="large"
                />
              }
              title={
                <>
                  <a
                    onClick={() => this.showModalView(item)}
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {item.informer ? item.informer : 'ไม่ได้ระบุผู้แจ้ง'}
                  </a>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 'normal',
                      color: '#8a8a8a',
                    }}
                  >
                    {item.date_inform && Moment().isValid()
                      ? Moment.unix(item.date_inform).format('lll')
                      : null}
                  </div>
                </>
              }
              description={
                <a onClick={() => this.showModalView(item)}>
                  {item.code ? item.code : 'ID#' + item.id}
                  <span
                    style={{
                      fontSize: 12,
                      color: '#222222',
                    }}
                  >
                    {item.home
                      ? ' ( ' +
                        item.home.home_no +
                        (item.home.plan_no
                          ? ' (แปลง' + item.home.plan_no + ')'
                          : '')
                      : ''}
                  </span>
                </a>
              }
            />

            <p onClick={() => this.showModalView(item)}>{item.description}</p>
            {item && item.canceled_remark ? (
              <div style={{ fontSize: 13 }}>
                <span style={{ textDecoration: 'underline' }}>
                  หมายเหตุยกเลิก:{' '}
                </span>
                <span style={{ marginLeft: 15, color: 'red' }}>
                  {item.canceled_remark}
                </span>
              </div>
            ) : (
              ''
            )}
            {/* <InformfixPostponeDetail item={item} /> */}
            <div
              style={{
                marginTop: 7,
              }}
            >
              {showMenuDrowDown(item)}
              <ButtonGroup>
                {/* <Button
                  icon={<SearchOutlined />}
                  size="small"
                  onClick={() => this.showModalView(item)}
                >
                  ดู
                </Button> */}
                {/* ################## ปุ่มแก้ไขใบแจ้งซ่อม ################ */}
                {/* {CanEdit(item) ? (
                  <Tooltip title="แก้ไขใบแจ้งซ่อม">
                    <Button
                      icon={<EditOutlined />}
                      size="small"
                      onClick={() => this.showModalEdit(item)}
                    >
                      แก้ไข
                    </Button>
                  </Tooltip>
                ) : null} */}

                {/* ################## ปุ่มยกเลิกใบแจ้งซ่อม ################ */}
                {/* {CanCancel(item) ? (
                  <Tooltip>
                    <Popconfirm
                      title={
                        'ต้องการยกเลิกใบแจ้งซ่อมเลขที่ ' +
                        item.id +
                        ' ใช่หรือไม่ ? (คิวงานทั้งหมดจะถูกยกเลิกด้วย)'
                      }
                      onConfirm={() => this.cancelInform(item)}
                    >
                      <Button
                        icon={<CloseOutlined />}
                        size="small"
                        type="default"
                      >
                        ยกเลิก
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                ) : null} */}
                {/* ################## ปุ่มลบใบแจ้งซ่อม ################ */}
                {/* {CanDelete(item) ? (
                  <Tooltip>
                    <Popconfirm
                      title={
                        'ต้องการลบใบแจ้งซ่อมเลขที่ ' +
                        item.id +
                        ' ใช่หรือไม่ ? (คิวงานทั้งหมดจะถูกยกเลิกด้วย รูปภาพจะถูกลบทิ้ง)'
                      }
                      onConfirm={() => this.deleteInform(item)}
                    >
                      <Button
                        icon={<DeleteOutlined />}
                        size="small"
                        type="danger"
                      >
                        ลบ
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                ) : null} */}
                {/* ################## ปุ่มยืนยันใบแจ้งซ่อมไปจัดคิวเมื่อเพิ่มรายละเอียดงานแล้ว ################ */}
                {/* {CanSendToManageTask(item) ? (
                  <Tooltip>
                    <Popconfirm
                      title={
                        'ต้องการส่งใบแจ้งซ่อมเลขที่ ' +
                        item.id +
                        ' ไปจัดคิวใช่หรือไม่ ?'
                      }
                      onConfirm={() => this.sendToManageTask(item)}
                    >
                      <Button icon={<SendOutlined />} size="small" type="light">
                        ส่งไปจัดคิวซ่อม
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                ) : null} */}
                {/* ################## ปุ่มจัดการคิวงาน ################ */}
                {CanAssignJob(item) ? (
                  <Tooltip title="จัดคิวงานซ่อม">
                    <Button
                      icon={<CalendarOutlined />}
                      size="small"
                      onClick={() => this.showModalAssign(item)}
                    >
                      จัดคิวงาน
                      {item.countJobs && item.countJobs > 0
                        ? ' (' + String(item.countJobs) + ')'
                        : null}
                    </Button>
                  </Tooltip>
                ) : null}
                <Button
                  icon={<SearchOutlined />}
                  size="small"
                  type="secondary"
                  // href={'/informfix/view/' + item.id}
                  // target="_blank"
                  onClick={() => this.showModalView(item)}
                >รายละเอียด</Button>
                {/* ################## ดูรายละเอียดคิวงาน ################ */}

                <Button
                  onClick={() => this.showModalViewJob(item)}
                  type="default"
                  size="small"
                  icon={<CalendarOutlined />}
                >
                  ดูคิวงาน {item.countJobs ? '(' + item.countJobs + ')' : null}
                </Button>
                {/* ################## ปุ่มส่งใบแจ้งซ่อมไปยืนยันลูกค้า################ */}
                {/* {CanSendToConfirm(item) ? (
                  <Tooltip>
                    <Popconfirm
                      title={
                        'ต้องการส่งใบแจ้งซ่อมเลขที่ ' +
                        item.id +
                        ' ไปรอยืนยันลูกค้าใช่หรือไม่ ?'
                      }
                      onConfirm={() => this.confirmTask(item)}
                    >
                      <Button
                        icon={<SendOutlined />}
                        size="small"
                        type="secondary"
                      >
                        ส่งต่อไป[รอยืนยัน]
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                ) : null} */}

                {/* ################## ปุ่มส่งใบแจ้งซ่อมไปยืนยันลูกค้าอีกรอบหลังจากเลือน ################ */}
                {/* {CanResendToConfirm(item) ? (
                  <Tooltip>
                    <Popconfirm
                      title={
                        'ต้องการส่งใบแจ้งซ่อมเลขที่ ' +
                        item.id +
                        ' ไปยืนยันลูกค้าใช่หรือไม่ ?'
                      }
                      onConfirm={() => this.reconfirmTask(item)}
                    >
                      <Button icon={<SendOutlined />} size="small" type="dark">
                        ส่งไปยืนยันนัดหมายอีกครั้ง
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                ) : null} */}
                {/* ################## ปุ่มยืนยันใบแจ้งซ่อมเมื่อคอนเฟิมร์กับลูกค้าแล้ว ################ */}
                {/* {CanConfirm(item) ? (
                  <Popconfirm
                    title={
                      'คุณต้องการยืนยันใบแจ้งซ่อมหมายเลข [' +
                      item.code +
                      '] ใช่หรือไม่ ？ (ระบบจะเปลี่ยนสถานะใบแจ้งซ่อมเป็น[ยืนยันแล้ว] คิวงานทั้งหมดถูกจ่ายงานทันที)'
                    }
                    onConfirm={() => this.changeStatusToConfirmed(item)}
                    placement="bottomLeft"
                  >
                    <Button
                      icon={<SendOutlined />}
                      size="small"
                      type="secondary"
                    >
                      ยืนยันคิวงาน
                    </Button>
                  </Popconfirm>
                ) : (
                  ''
                )} */}
                {CanConfirmJob(item) ? (
                  <Popconfirm
                    title={
                      'คุณต้องการส่งงานไปให้ช่าง ใช่หรือไม่ ？ (ระบบจะเปลี่ยนสถานะใบแจ้งซ่อมเป็น[อยู่ระหว่างเนินการ] คิวงานทั้งหมดจะถูกเปลี่ยนเป็น[อยู่ระหว่างเนินการ])'
                    }
                    onConfirm={() => this.changeStatusToProceed(item)}
                    placement="bottomLeft"
                  >
                    <Button
                      icon={<SendOutlined />}
                      size="small"
                      type="secondary"
                    >
                      ส่งงานให้ช่าง !
                    </Button>
                  </Popconfirm>
                ) : (
                  ''
                )}
                {CanPostponeJob(item) ? (
                  <React.Fragment>
                    <Button
                      onClick={() => this.showModalPostponeJob(item)}
                      type="default"
                      size="small"
                      icon={<ReloadOutlined />}
                    >
                      แจ้งเลื่อนคิว
                    </Button>
                  </React.Fragment>
                ) : (
                  ''
                )}

                {/* <a
                  title="ดาวน์โหลดแบบฟอร์มเข้าซ่อมบ้าน"
                  rel="noopener noreferrer"
                  href={item.linkExportWord}
                  target="_blank"
                  className="ant-btn ant-btn-sm"
                  style={{ backgroundColor: 'yellow', color: '#222222' }}
                >
                  <DownloadOutlined /> ดาวน์โหลดแบบฟอร์ม
                </a> */}
                {CanCloseInform(item) ? (
                  <React.Fragment>
                    <Popconfirm
                      title={
                        'คุณต้องการปิดงานทั้งหมดในใบแจ้งซ่อม ใช่หรือไม่ ？ \r(ระบบจะเปลี่ยนสถานะใบแจ้งซ่อมเป็น[ปิดงาน] คิวงานทั้งหมดจะถูกเปลี่ยนเป็น[เสร็จแล้ว])'
                      }
                      onConfirm={() => this.changeStatusToComplete(item)}
                      placement="bottomLeft"
                    >
                      <Button
                        icon={<CheckSquareOutlined />}
                        size="small"
                        type="default"
                      >
                        ปิดงานซ่อมทั้งหมด !
                      </Button>
                    </Popconfirm>
                  </React.Fragment>
                ) : (
                  ''
                )}
              </ButtonGroup>
            </div>
          </List.Item>
        )}
      ></List>
    )

    return (
      <React.Fragment>
        {listData}

        {/* ////////////// START Modal assign job /////////// */}
        <Modal
          open={this.state.showFormAssign}
          bodyStyle={{
            padding: '5px',
          }}
          footer=""
          style={{
            top: 5,
          }}
          width="95%"
          title={
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 15 }}
                lg={{ span: 15 }}
              >
                <strong>{this.props.informStore.getItem.subject}</strong>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 9 }}
                lg={{ span: 9 }}
              >
                <InformfixStatus
                  name={this.props.informStore.getItem.workStatusName}
                  statusId={this.props.informStore.getItem.work_status}
                />

                {/* {CanSendToConfirm(this.props.informStore.getItem) &&
                this.props.informStore.getItem.countJobs > 0 ? (
                  <Popconfirm
                    title={
                      'คุณต้องการยืนยันคิวงานทั้งหมด ใช่หรือไม่ ？ (ระบบจะเปลี่ยนสถานะใบแจ้งซ่อมเป็น[รอยืนยัน])'
                    }
                    onConfirm={() =>
                      this.confirmTask(this.props.informStore.getItem)
                    }
                    placement="bottomLeft"
                  >
                    <Space/><Space/>
                    <Button icon={<SendOutlined />} type="primary">
                      ส่งต่อไป [รอยืนยัน] !
                    </Button>
                  </Popconfirm>
                ) : null} */}

                {this.props.informStore.getItem.countJobs == 0
                  ? 'ขณะนี้ยังไม่มีคิวงานใดๆ'
                  : null}
              </Col>
            </Row>
          }
        >
          {this.state.showFormAssign && this.state.inform ? (
            <AssignJob
              key="assingjob"
              inform={this.state.inform}
              informfixId={this.state.editId}
              listStatus={this.listStatus}
              showButtoncloseJob={CanSetToComplete(this.state.inform)}
            />
          ) : null}
        </Modal>
        {/* ////////////// END Modal assign job /////////// */}

        {/* ////////////// START Modal VIEW /////////// */}
        <Modal
          key="modal-view"
          title={
            'ดูรายละเอียดใบแจ้งซ่อม  ID#' +
            (this.state.inform && this.state.inform.id !== undefined
              ? this.state.inform.id
              : '') +
            ' | ' +
            (this.state.inform && this.state.inform.workStatusName !== undefined
              ? this.state.inform.workStatusName
              : '')
          }
          open={this.state.showFormView}
          cancelText="ปิดหน้าต่าง"
          maskClosable
          onCancel={this.hideModalView}
          footer=""
          bodyStyle={{
            padding: '5px',
            backgroundColor: '#222222',
            color: '#ffffff',
          }}
          style={{ top: 5 }}
          destroyOnClose
          width={960}
        >
          {this.state.inform && this.state.showFormView ? (
            <InformView
              itemId={this.state.viewId}
              home={this.state.homeDetail}
              photos={this.state.inform ? this.state.inform.images : []}
              item={this.state.inform}
              jobs={this.state.informJobs}
              jobStatuses={this.state.listJobStatus}
              hideModal={this.hideModalView}
              dateMode="normal"
            />
          ) : null}
        </Modal>

        {/* ////////////// START Modal VIEW Job /////////// */}
        <Modal
          key="modal-jobdetail"
          title={'รายละเอียดงาน ใบแจ้งซ่อม #' + this.state.viewDetailJobId}
          open={this.state.viewDetailJobId > 0}
          cancelText="ปิดหน้าต่าง"
          maskClosable
          onCancel={this.hideModalViewJob}
          footer=""
          bodyStyle={{
            padding: '7px',
            backgroundColor: '#ffffff',
            color: '#222222',
          }}
          style={{ top: 5 }}
          destroyOnClose
        >
          {this.state.inform && this.state.viewDetailJobId > 0 ? (
            <JobClose
              itemId={this.state.viewDetailJobId}
              jobs={this.props.informStore.getJobItems}
              hideModal={this.hideModalViewJob}
              onCloseJob={(data) => {
                const list = this.props.informStore.getItems
                list.map((item, index) => {
                  if (item.id == data.inform.id) {
                    list[index].work_status = data.inform.work_status
                    list[index].workStatusName = data.inform.workStatusName
                    this.props.informStore.setItems(list)
                    this.setState({
                      data: list,
                    })
                    this.props.onWorkstatusChange()
                  }
                })
              }}
            />
          ) : null}
        </Modal>
        {/* ////////////// END Modal VIEW job  /////////// */}
        {/* ////////////// START Modal เลื่อนนัดคิวงาน  /////////// */}

        {this.state.showFormPostponeJob ? (
          <JobPostpone
            visible={this.state.showFormPostponeJob}
            onHide={(value) => {
              this.setState({
                showFormPostponeJob: value,
              })
            }}
            itemId={this.state.viewId}
            jobs={this.props.informStore.getJobItems}
          />
        ) : null}
        {/* ////////////// END Modal เลื่อนนัดคิวงาน /////////// */}
        
        {/* ////////////// start Modal ADD /////////// */}
        <Modal
          title="เพิ่มใบแจ้งซ่อมใหม่"
          key="modal-add"
          open={this.props.showFormAdd}
          closable
          footer=""
          onCancel={() => this.hideModalAdd()}
          destroyOnClose
        >
          {this.props.showFormAdd ? (
            <InformFormAdd
              hideModal={() => this.hideModalAdd()}
              onCreated={(data) => {
                console.log('onCreated', data)
                this.props.reload()
                this.showModalEdit(data, 1)
              }}
            />
          ) : (
            ''
          )}
        </Modal>
        {/* ////////////// END Modal ADD /////////// */}

        
        {/* ////////////// START Modal Edit /////////// */}
        {this.state.editId && this.state.showFormEdit ? (
        <Modal
          title="แก้ไขใบแจ้งซ่อม"
          open={this.state.showFormEdit}
          onCancel={this.hideModalEdit}
          footer=""
          bodyStyle={{
            padding: '10px',
          }}
          style={{ top: 5 }}
          destroyOnClose
        >
  
            <InformEdit
              key={this.state.editId}
              informfixId={this.state.editId}
              onUpdate={(inform) => {
                const informfix = this.props.informStore.getItem
                let data = this.props.informStore.getItems
                if (informfix) {
                  data.map((i, index) => {
                    if (i.id == informfix.id) {
                      data[index] = informfix
                    }
                  })
                  this.setState({
                    data: data,
                  })
                }
              }}
              onUpdateJobs={(jobs, id) => {
                if (jobs) {
                  let data = this.props.informStore.getItems
                  data.map((item, key) => {
                    if (id.toString() == item.id.toString()) {
                      data[key].informJobs = jobs
                      data[key].countJobs = jobs.length
                      console.log('updatejob', jobs, data.length)
                      this.setState({
                        data: jobs,
                      })
                    }
                  })
                }
              }}
              hideModal={() => {
                this.hideModalEdit()
              }}
              formStep={this.state.formStep ? this.state.formStep : 0}
            />

        </Modal>
          ) : null}
        {/* ////////////// END Modal Edit /////////// */}


        {/* ////////////// start modal cancel  /////////// */}
        {this.state.inform && this.state.showFormCancel ? (
          <>
            <Modal
              title={`ต้องการยกเลิกใบแจ้งซ่อม เลขที่ : ${this.state.inform.code} ใช่หรือไม่ ? `}
              open={this.state.showFormCancel}
              okText="ยืนยันยกเลิก"
              cancelText="ปิด"
              onOk={this.onSubmitCancel}
              onCancel={() => {
                this.setState({
                  showFormCancel: false,
                })
              }}
            >
              {this.state.inform && this.state.inform.description ? (
                <>{this.state.inform.description}</>
              ) : (
                ''
              )}
              {this.state.inform && this.state.inform.canceled_remark ? (
                <>
                  <small style={{ textDecoration: 'underline' }}>
                    หมายเหตุยกเลิก:{' '}
                  </small>
                  <small style={{ color: 'red', fontSize: 12, marginLeft: 10 }}>
                    {this.state.inform.canceled_remark}
                  </small>
                </>
              ) : (
                ''
              )}
              <Form
                ref={this.formCancelRef}
                onFinish={this.handleSubmitCancel}
                style={{ display: 'block' }}
                layout="vertical"
                initialValues={{
                  id: this.state.inform ? this.state.inform.id : '',
                  canceled_remark: this.state.inform
                    ? this.state.inform.canceled_remark
                    : '',
                }}
              >
                <p style={{ fontStyle: 'italic' }}></p>
                <Form.Item
                  name="id"
                  rules={[{ required: true, message: 'JobID' }]}
                  shouldUpdate
                  noStyle
                >
                  <Input placeholder="รหัสงาน" disabled={true} />
                </Form.Item>
                <Form.Item
                  label="หมายเหตุยกเลิก"
                  name="canceled_remark"
                  shouldUpdate
                  rules={[
                    { required: true, message: 'โปรดระบุหมายเหตุยกเลิก' },
                  ]}
                >
                  <TextArea rows={4} placeholder="หมายเหตุยกเลิก" />
                </Form.Item>
              </Form>
            </Modal>
          </>
        ) : (
          ''
        )}

        {/* ////////////// end modal cancel  /////////// */}
      </React.Fragment>
    )
  }
}

export default InformListComponent
